import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>
  `,
    standalone: false
})
export class BootstrapComponent {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    translate.setDefaultLang('en');
    translate.use(translate.getBrowserLang() === 'nl' ? 'nl' : 'en');

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          let lastTitle = null;

          while (child) {
            if (child.snapshot.data && child.snapshot.data['title']) {
              lastTitle = child.snapshot.data['title'];
            }

            if (child.firstChild) {
              child = child.firstChild;
            } else {
              return lastTitle;
            }
          }
          return null;
        }),
      )
      .subscribe((title: any) => {
        if (title) {
          this.titleService.setTitle(title + ' - Appic Dashboard');
        } else {
          this.titleService.setTitle('Appic Dashboard');
        }
      });
  }
}
